export default __webpack_public_path__ + "static/media/EUROSTILE-BOLDEXTENDEDTWO.bba07dd1.OTF";